if (location.hash) {
    setTimeout(function() {

        window.scrollTo(0, 0);
    }, 1);
}

var mapStyle = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#9ab1a8"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#4d4d4f"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f0edea"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];

var scrollP = 0.1;
var $grid;
$(document).ready(function() {
    $.ajaxSetup({cache: false});

    // check if file1 is not bigger than 8 mb and is an image file
    $('#foto1, #foto2, #foto3').bind('change', function() {
        var file1 = $(this)[0].files[0];
        if (file1.size > (8 * 1024 * 1024)) {
            alert('File is too big!');
            $(this).val('');
        }
    });


    $('#datum, #datum_tot, #datum_van').datetimepicker({
        format: 'DD-MM-YYYY',
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'icon-box icon-arrow-up',
            down: 'icon-box icon-arrow-down',
            previous: 'icon-box icon-arrow-left',
            next: 'icon-box icon-arrow-right',
            today: 'far fa-calendar-check-o',
            clear: 'far fa-trash',
            close: 'icon-box icon-close'
        }
    });

    $('#tijd').datetimepicker({
        format: 'HH:mm',
        icons: {
            time: 'far fa-clock',
            date: 'far fa-calendar',
            up: 'icon-box icon-arrow-up',
            down: 'icon-box icon-arrow-down',
            previous: 'icon-box icon-arrow-left',
            next: 'icon-box icon-arrow-right',
            today: 'far fa-calendar-check-o',
            clear: 'far fa-trash',
            close: 'icon-box icon-close'
        }
    });

    $('#danger-form').validate({
        submitHandler: function(form) {
            $('#danger-form .alert-success').addClass('d-none');
            $('#danger-form .alert-danger').addClass('d-none');
            // create an empty, hidden iframe to post the form to
            var iframe = $('<iframe style="display: none;" name="postiframe" id="postiframe" />');
            iframe.appendTo("body");
            form.target = "postiframe";
            form.action = window.base_url + 'engine/danger.php';
            // submit form to the iframe
            form.submit();
        }
    });

    $('#danger-form-light').validate({
        submitHandler: function(form) {
            $('#danger-form-light .alert-success').addClass('d-none');
            $('#danger-form-light .alert-danger').addClass('d-none');
            // create an empty, hidden iframe to post the form to
            var iframe = $('<iframe style="display: none;" name="postiframe" id="postiframe" />');
            iframe.appendTo("body");
            form.target = "postiframe";
            form.action = window.base_url + 'engine/danger-light.php';
            // submit form to the iframe
            form.submit();
        }
    });

    $('#layby-form').validate({
        submitHandler: function(form) {
            $('#layby-form .alert-success').addClass('d-none');
            $('#layby-form .alert-danger').addClass('d-none');
            // create an empty, hidden iframe to post the form to
            var iframe = $('<iframe style="display: none;" name="postiframe" id="postiframe" />');
            iframe.appendTo("body");
            form.target = "postiframe";
            form.action = window.base_url + 'engine/layby.php';
            // submit form to the iframe
            form.submit();



        }

    });



    $('.top-carrousel ul.bxslider').bxSlider({
        mode: 'fade',
        pager: false,
        controls: false,
        auto: true,
        //nextSelector: $('.pageheader .next_btn'),
        //prevSelector: $('.pageheader .prev_btn'),
        nextText: '',
        prevText: '',
        touchEnabled: true
    });


    $('.carrousel-trm ul.bxslider').bxSlider({
        mode: 'fade',
        pager: false,
        controls: false,
        auto: true,
        //nextSelector: $('.pageheader .next_btn'),
        //prevSelector: $('.pageheader .prev_btn'),
        nextText: '',
        prevText: '',
        touchEnabled: true
    });

    $('.carrousel-combi ul.bxslider').bxSlider({
        mode: 'fade',
        pager: false,
        controls: false,
        auto: true,
        //nextSelector: $('.pageheader .next_btn'),
        //prevSelector: $('.pageheader .prev_btn'),
        nextText: '',
        prevText: '',
        touchEnabled: true
    });
    $('.linkbox').width($('.complete-view').width());
    $('.linkbox').css('left', ($('.complete-view').parent().width() - $('.complete-view').width()) / 2);

    $('.carrousel-quotes ul.bxslider').bxSlider({
        mode: 'fade',
        pager: false,
        controls: true,
        auto: true,
        pause: 12000,
//        nextSelector: $('.carrousel-quotes .next_btn'),
//        prevSelector: $('.carrousel-quotes .prev_btn'),
        nextText: '',
        prevText: '',
        touchEnabled: true
    });


    // if ($( ".marker" ).length > 0) $( ".marker" ).draggable();
    $('.marker').click(function (e) {
        e.preventDefault();
        // window.location.href = $(this).data('url');
        var terminal_id = $(this).data('terminal_id');
        $('.terminals-intro').hide();
        $('.marker').removeClass('active');
        $(this).addClass('active');
        $('#terminal-' + terminal_id).show();
    });


    $('.map-filter a').click(function(e) {
        e.preventDefault();
        var filter = $(this).data('filter');

        if (filter.length > 0) {
            $('#hes-terminal-map .marker').addClass('hidden');
            $('#hes-terminal-map .marker.' + filter).removeClass('hidden');
        } else {
            $('#hes-terminal-map .marker').removeClass('hidden');
        }
    });

    if (window.location.hash != '') {
        if (window.location.hash == '#annex') {
            $(window.location.hash).removeClass('d-none');


            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top - 320
            }, 200);
        } else {
            $('a[data-filter=' + window.location.hash.substr(1) + ']').trigger('click');
            $('a[data-filter=' + window.location.hash.substr(1) + ']').focus();
        }
    }

    $('#filter-news').click(function(e) {
        e.preventDefault();
        $('#filter-form').submit();
    });
    $('.filter-jaar').click(function(e) {
        e.preventDefault();
        $('#filter-jaar').val($(this).data('jaar'));
        $('#filter-form').submit();
    });

    $('.block').fitVids();

    $('.cod-lang').click(function(e) {
        e.preventDefault();
        $('.content-code_21').addClass('collapse').removeClass('collapsed');
        $('.content-code-30').addClass('collapse').removeClass('collapsed');
        $('.content-40').addClass('collapse').removeClass('collapsed');
        $('.content-20').addClass('collapse').removeClass('collapsed');
        $('a.toggle[aria-expanded=true]').trigger('click');
        var hash = $(this).prop('href').substr($(this).prop('href').indexOf('#') + 1);
        $('.content-20.' + hash + ':not(.coc-area)').addClass('collapsed').removeClass('collapse');
        $('.content-40.' + hash + ':not(.coc-area)').addClass('collapsed').removeClass('collapse');
        $('.content-code_21.' + hash).addClass('collapsed').removeClass('collapse');
        $('.content-code-30.' + hash).addClass('collapsed').removeClass('collapse');
    });

    if ($('.pageheader').outerHeight() < $('.pageheader hgroup').outerHeight()) {
        $('.content section:eq(0)').css('paddingTop', $('.pageheader hgroup').height());
        $('.content section:eq(0) aside').css('marginTop', -1 * $('.pageheader hgroup').height());
    }

    $('p.contact-name').each(function(i) {
       var $parent = $(this).parent();
        var $d_name = $('<div>');
        $d_name.addClass('contact-name');
        $parent.find('p.contact-name').removeClass('name-info').appendTo($d_name);
        var $d_info = $('<div>');
        $d_info.addClass('contact-info');
        $parent.find('p.contact-info').removeClass('contact-info').appendTo($d_info);
        $d_info.prependTo($parent);
        $d_name.prependTo($parent);

    });

    $("a[href*='#covid']").click(function (e) {
        e.preventDefault();
        $('.covid').addClass('show');

    });
    $("#close-covid").click(function (e) {
        e.preventDefault();
        $('.covid').removeClass('show');

    });

    $("a[href*='#vertrouwenspersoon']").click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top - $('#header').height()
        }, 200);
    });

    if ($(window).width() > 767) {
        equalHeights('div.contact-name', '.content-area-own');
        equalHeights('div.contact-info', '.content-area-own');
        equalHeights('div.contact-name', '.content-area-jv');
        equalHeights('div.contact-info', '.content-area-jv');
    }

    $('.content-40, .content-40 .block').on('shown.bs.collapse', function () {
        if ($(window).width() > 767) {
            $('section.content-40 h3.underline').addClass('eqh');
            equalHeights('h3.underline', 'section.content-40 .collapse.show');
            equalHeights('h3.underline', 'section.content-40.collapse.show');
        }
    });


    $("img.popup-image").each(function (index) {
        var $img = $(this);
        var $a = $('<a data-lightbox="image-' + index + '" data-title="' + $img.prop('alt') + '">');
        $a.prop('href', $img.prop('src'));
        console.log($a.data());
        $a.appendTo($img.parent());
        $img.prependTo($a);
    });


    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true,

    });


});

$(document).scroll(function() {
    var windowTop = $(window).scrollTop(),
        windowWidth = $(window).width(),
        windowHeight = $(window).height(),
        visualHeight = $('#header').height(),
        footerTop = $('footer').offset().top;

    if (windowTop > visualHeight * scrollP ) {
        $('body').addClass('in-scroll')
    }
    //console.log((windowTop > (windowHeight * 0.2)) + ' -- ' + ( (footerTop - windowHeight) < windowTop ) + ' = ' + footerTop + ' - ' + windowHeight + ' - ' + windowTop + ' - ');
    //console.log((windowTop) + ' -- ' + visualHeight);
    if ( (windowTop < visualHeight * scrollP ) || (windowTop == 0) ) {
        $('body').removeClass('in-scroll')
    }



});



function equalHeights(element, container){
    if (typeof container === 'undefined') {
        c = $(element).parent();
    } else {
        c = $(container);
    }

    var highestBox = 0;
    c.find(element).each(function(){
        highestBox = Math.max(highestBox, $(this).outerHeight());
    });
    //console.log(highestBox);
    c.find(element).outerHeight(highestBox);

}

function gmap3_ready_steady_go() {
    /*
    Gmap3 functionality
    Needed for blocks: 130, 131
    */
    $('.gmap').each(function( index ) {
        var gmap_address = $(this).data('address');
        var gmap_icons = ($('#trm-icons').length == 1) ? $('#trm-icons').html() : '';
        var gmap_name = $(this).data('name');
        $(this).gmap3({
            address: gmap_address,
            zoom: 12,
            mapTypeId: "style1"
        })
            .infowindow( {
                address: gmap_address,
                content: "<a href='https://maps.google.com/?daddr=" + gmap_address + "' target='_blank'>" + gmap_icons + "" + gmap_name + "</a>"
            })
            .then(function (infowindow) {
                infowindow.open(this.get(0)); // this.get(0) return the map (see "get" feature)
            })
            .styledmaptype(
                // styleId (gmap3)
                "style1", mapStyle, {name: "Style 1"});

    });


    $('.gmap-extra').each(function( index ) {
        var gmap_address = $(this).data('address');
        var gmap_icons = ($('#trm-icons').length == 1) ? $('#trm-icons').html() : '';
        var gmap_name = $(this).data('name');
        $('.gmap').gmap3({
            address: gmap_address,
            zoom: 12,
            mapTypeId: "style1"
        })
            .infowindow( {
                address: gmap_address,
                content: "<a href='https://maps.google.com/?daddr=" + gmap_address + "' target='_blank'>" + gmap_icons + "" + gmap_name + "</a>"
            })
            .then(function (infowindow) {
                infowindow.open(this.get(0)); // this.get(0) return the map (see "get" feature)
            })
            .styledmaptype(
                // styleId (gmap3)
                "style1", mapStyle, {name: "Style 1"});
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const lazyLoadBackgrounds = document.querySelectorAll(".lazy-load-bg");

    if ("IntersectionObserver" in window) {
        let lazyLoadObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyBackground = entry.target;
                    let bgImage = lazyBackground.getAttribute('data-bg');

                    // Apply the background image
                    lazyBackground.style.backgroundImage = `url('${bgImage}')`;

                    // Optionally remove the class if you want
                    lazyBackground.classList.remove("lazy-load-bg");

                    // Stop observing once the image is loaded
                    lazyLoadObserver.unobserve(lazyBackground);
                }
            });
        });

        lazyLoadBackgrounds.forEach(function(lazyBackground) {
            lazyLoadObserver.observe(lazyBackground);
        });
    } else {
        // Fallback if IntersectionObserver is not supported
        lazyLoadBackgrounds.forEach(function(lazyBackground) {
            let bgImage = lazyBackground.getAttribute('data-bg');
            lazyBackground.style.backgroundImage = `url('${bgImage}')`;
            lazyBackground.classList.remove("lazy-load-bg");
        });
    }
});

function iframe_succes(formname) {
    $('#'+formname + ' .alert-success').removeClass('d-none');
    $('#'+formname )[0].reset();
}

function iframe_error(formname) {
    $('#'+formname + ' .alert-danger').removeClass('d-none');
}